<template>
	<div class="">
		<el-button type="primary" size="small" @click="add">新建节点</el-button>
		<el-button type="danger" size="small" @click="del">删除节点</el-button>
		<el-button type="info" size="small" @click="init">初始化</el-button>
		<el-divider>流程图</el-divider>
		<div class=" flowgraph" id="flowgraph"></div>
		<div class="minimapContainer" ref="minimapContainer"></div>
		
		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" @submit="nodesubmit" />

	</div>

</template>
<style scoped>
	.flowgraph {
		box-shadow: 0px 0px 6px #909399;
	}
	.minimapContainer{
		position: absolute;
		top: 0;
		right: 0;
		box-shadow: 0px 0px 10px grey;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			formCreateInject: {
				default: () => {
					return null
				}
			},
			width: {
				type: String,
				default: () => {
					return "800"
				}
			},
			height: {
				type: String,
				default: () => {
					return "500"
				}
			},
			flowid: {
				default: () => {
					return 0
				}
			},
			formid: {
				type: Number,
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					extra: {},
					controlltype: 1,
				},
				modalShow: true,
				ready: false,
				options: [],
				graph: null,
				node: [],
				formData: {
					name: 'flownode',
					id: 0,
					controlltype: 1,
					type: "add",
					show: false,
					flow: null,
					node: []
				},
			}
		},
		created() {

		},
		mounted() {
			
			this.$nextTick(() => {
				this.graph = new this.$Graph({
					container: document.getElementById('flowgraph'),
					width: this.width,
					height: this.height,
					scroller: false,
					snapline: true,
					minimap: {
						width:200,
						height:100,
						enabled: true,
						container: this.$refs.minimapContainer,
						graphOptions: {
							async: true,
							// getCellView(cell) {
							// 	if (cell.isNode()) {
							// 		return SimpleNodeView
							// 	}
							// },
							createCellView(cell) {
								if (cell.isEdge()) {
									return null
								}
							},
						}
					},
					background: {
						color: '#fffbe6', // 设置画布背景颜色
					},
					grid: {
						size: 10, // 网格大小 10px
						visible: true, // 渲染网格背景
					},
					selecting: {
						enabled: false,
						rubberband: false,
						showNodeSelectionBox: false,
						filter(node) {
							if (node.shape != 'edge') {
								return node.data.nodetype != 999 && node.data.nodetype != 998
							} else {
								return true
							}

						},
					},
					mousewheel: {
						enabled: true
					},
				})
				//this.graph.centerContent()
				// this.graph.on('node:selected', () => {
				// 	this.node = this.graph.getSelectedCells()
				// })
				// this.graph.on('node:unselected', () => {
				// 	this.node = this.graph.getSelectedCells()

				// })

				// this.graph.on('node:mouseup', () => {

				// 	this.change(this.graph.toJSON())
				// })
				this.graph.on('node:contextmenu', ({
					node
				}) => {
					this.graph.removeNode(node)
				})
				this.graph.on('node:dblclick', ({
					node
				}) => {
					this.node = [node]
					this.edit()
				})
				this.graph.on('edge:contextmenu', ({
					edge
				}) => {
					this.graph.removeEdge(edge)
				})
				this.graph.on('edge:mouseup', ({
					edge
				}) => {
					if (!edge.target.cell) {
						this.graph.removeEdge(edge)
					}
				})
				this.graph.on('edge:connected', ({
					edge
				}) => {
					let sourceNode = edge.getSourceNode()
					let sourceNodeData = sourceNode.getData()
					let sourceNodeOutEdges = this.graph.getOutgoingEdges(sourceNode)
					if (sourceNodeOutEdges.length <= 1 || sourceNodeOutEdges.length <= 2 && sourceNodeData
						.nodetype == 2) {
						let targetNode = edge.getTargetNode()
						let targetNodePorts = targetNode.getPorts()
						let buff = false
						targetNodePorts.forEach((item) => {
							if (item.id == 'in') {
								buff = true
							}
						})
						if (buff) {
							edge.setTarget({
								cell: targetNode.id,
								port: 'in'
							})

							if (edge.source.cell == edge.target.cell) {
								this.graph.removeEdge(edge)
							}
							let edges = this.graph.getEdges()
							edges.forEach((item) => {
								if (item.source.cell == edge.source.cell && item.source.port ==
									edge
									.source
									.port && item.target.cell == edge.target.cell && item.target
									.port ==
									edge.target.port && item.id != edge.id) {

									this.graph.removeEdge(edge)
								}

							})
						} else {
							this.graph.removeEdge(edge)
						}
					} else {
						this.graph.removeEdge(edge)
					}

				})
				this.graph.zoom(-0.5)
				//this.graph.centerContent()
				//this.init()

			})
		},
		watch: {
			value(val) {
				// let model = {
				// 	nodes: [],
				// 	edges: [],
				// }
				// val.cells.forEach((item) => {
				// 	if (item.shape == 'edge') {
				// 		model.edges.push(item)
				// 	} else {
				// 		model.nodes.push(item)
				// 	}
				// })
				//let newModel = this.$DagreLayout.layout(model)
				this.graph.fromJSON(val)
			}
		},
		computed: {

		},

		methods: {
			init() {
				this.graph.clearCells()
				let sponwernode = this.graph.addNode(this.addNode('sponser', {
					nodetype: 998,
					name: '发起'
				}))
				let staffnode = this.graph.addNode(this.addNode('staff', {
					nodetype: 1,
					tag: '协同',
					name: '人员'
				}))
				let endnode = this.graph.addNode(this.addNode('end', {
					nodetype: 999,
					name: '结束'
				}))
				this.graph.addEdge({
					shape: 'edge',
					source: {
						cell: sponwernode,
						port: 'out'
					},
					target: {
						cell: staffnode,
						port: 'in'
					}
				})
				this.graph.addEdge({
					shape: 'edge',
					source: {
						cell: staffnode,
						port: 'out'
					},
					target: {
						cell: endnode,
						port: 'in'
					}
				})

				
				let json = this.graph.toJSON()
				let model = {
					nodes: [],
					edges: [],
				}
				json.cells.forEach((item) => {
					if (item.shape == 'edge') {
						model.edges.push(item)
					} else {
						model.nodes.push(item)
					}
				})
				let newModel = this.$DagreLayout.layout(model)
				this.graph.fromJSON(newModel)


			},
			list() {

			},
			nodesubmit(e) {
				let data = e.data


				if (e.type == 'update') {
					this.updateNode(data)
				} else {
					if (data.nodetype == 998) {
						this.graph.addNode(this.addNode('sponser', data))
					}
					if (data.nodetype == 999) {
						this.graph.addNode(this.addNode('end', data))
					}
					if (data.nodetype == 997) {
						this.graph.addNode(this.addNode('audit', data))
					}
					if (data.nodetype == 996) {
						this.graph.addNode(this.addNode('sonflow', data))
					}
					if (data.nodetype == 1) {
						this.graph.addNode(this.addNode('staff', data))
					}
					if (data.nodetype == 2) {
						this.graph.addNode(this.addNode('logic', data))
					}
					if (data.nodetype == 3) {
						this.graph.addNode(this.addNode('inform', data))
					}
				}

			},
			addNode(type, data) {
				//let r = 10
				let cell = {
					data: data,
					shape: type,
					attrs: {
						tag: {
							text: data.tag?data.tag:null,
						},
						name: {
							text: data.name,
						}
					}
				}
				// if (type == 'sponser') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'sponser',
				// 		attrs: {
				// 			name: {
				// 				text: data.name,
				// 			}
				// 		}
				// 	}
				// }
				// if (type == 'staff') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'staff',
				// 		attrs: {
				// 			tag: {
				// 				text: data.tag,
				// 			},
				// 			name: {
				// 				text: data.name,
				// 			},
				// 		}
				// 	}
				// }
				// if (type == 'logic') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'logic', // 指定使用何种图形，默认值为 'rect'
				// 		attrs: {
				// 			name: {
				// 				text: data.name,
				// 			}
				// 		},
				// 	}
				// }
				// if (type == 'audit') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'audit', // 指定使用何种图形，默认值为 'rect'
				// 		attrs: {
				// 			name: {
				// 				text: data.name,
				// 			}
				// 		}
				// 	}
				// }	
				// if (type == 'inform') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'inform', // 指定使用何种图形，默认值为 'rect'
				// 		attrs: {
				// 			tag: {
				// 				text: data.tag,
				// 			},
				// 			name: {
				// 				text: data.name,
				// 			},
				// 		},
				// 	}
				// }
				// if (type == 'audit') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'audit', // 指定使用何种图形，默认值为 'rect'
				// 		attrs: {
				// 			name: {
				// 				text: data.name,
				// 			}
				// 		}
				// 	}
				// }
												
				// if (type == 'end') {
				// 	cell = {
				// 		data: data,
				// 		shape: 'end', // 指定使用何种图形，默认值为 'rect'
				// 		attrs: {
				// 			name: {
				// 				text: data.name,
				// 			}
				// 		}
				// 	}
				// }

				return cell
			},
			updateNode(data) {
				console.log(data)
				this.node[0].setData(data, {
					overwrite: true
				})
				//console.log(this.node[0].getData())
				let eventtext = (data.event && Object.keys(data.event).length)?1:0
				this.node[0].setAttrs({
					tag: {
						text: data.tag
					},
					name: {
						text: data.name
					},
					eventicon:{
						opacity:eventtext
					}
				})
			},

			add() {				
				import('./node.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'flownode',
						show: true,
						extra: {							
							type: 'add',
							flow: this.graph.getNodes(),
							componentname:this.formCreateInject.api.getValue('componentname')
							//node: this.node[0]
						},
						foreingKey: {
							formid: this.formid,
							flowid:this.flowid,
						},
						controlltype: 1,
					}
				})
			},
			edit() {
				//console.log(this.formCreateInject.api.getValue('componentname'))
				if (this.node.length == 1) {
					//if (this.node[0].data.nodetype != 999 && this.node[0].data.nodetype != 998) {
					import('./node.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'flownode',
							id: this.node[0].id,
							show: true,
							extra: {								
								type: 'update',
								flow: this.graph.getNodes(),
								node: this.node[0],
								componentname:this.formCreateInject.api.getValue('componentname')
							},
							foreingKey: {
								formid: this.formid,
								flowid:this.flowid,
							},
							controlltype: 2,
						}
					})
					//}
				} else {
					this.$message.error('请选择一个节点')
				}
			},

			formBack() {
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					extra: {},
					controlltype: 1,
				}
			},
			del() {
				this.node.forEach((item) => {
					this.graph.removeNode(item)
				})
				this.node = []
			},
			clearSelect() {
				this.node.forEach((item) => {
					this.graph.unselect(item)
				})
			},

		},
		components: {

		}
	}
</script>
